export { default as Delete } from "./Delete/Delete";
export { default as Form } from "./Form/Form";
export { default as InformUnchange } from "./InformUnchange/InformUnchange";
